// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__3DzaB","item":"styles_item__2RAsG","subitem":"styles_subitem__v8Q6u","active":"styles_active__3LBJk","hiddenMenuItem":"styles_hiddenMenuItem__3mgAy"};